import { render } from "./ownerResp.vue?vue&type=template&id=b7f4cb92&scoped=true"
import script from "./ownerResp.vue?vue&type=script&lang=js"
export * from "./ownerResp.vue?vue&type=script&lang=js"

import "./ownerResp.vue?vue&type=style&index=0&id=b7f4cb92&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f4cb92"]])

export default __exports__